/**
 *
 * @page 用户中心/我的消息/系统消息
 *
 **/
import { Pagination } from 'antd';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import { useStoreState } from '&/utils/customHooks';
import MessageItem from '@/components/UserCenter/MessageItem';
import BaseListWrap from '&/components/BaseListWrap';
import useMessage from '@/utils/customHooks/useMessage';

function SystemMsg(props) {
    const persenCenter = useStoreState('useStoreState');
    const [
        msgList,
        loading,
        total,
        queryForm,
        onPageChange,
        deleteMsg,
        markAsRead,
    ] = useMessage(2, persenCenter.queryUnreadAmount);

    const headerRight = (
        <button className="text-btn" onClick={() => markAsRead()}>
            {intl.get('userCenter.markAllRead')}
        </button>
    );

    return (
        <BasePageWrap type="card" title="系统消息" headerRight={headerRight}>
            <BaseListWrap isLoading={loading} isEmpty={!!msgList.length}>
                {msgList.map(e => (
                    <MessageItem
                        key={e.id}
                        content={e.content}
                        data={e}
                        onClick={() => markAsRead([e.id], e.status)}
                        deleteMsg={deleteMsg}
                    />
                ))}

                <Pagination
                    size="small"
                    current={queryForm.page}
                    onChange={onPageChange}
                    pageSize={queryForm.limit}
                    total={total}
                    showSizeChanger={true}
                    showTotal={total => intl.get('base.total', { total })}
                />
            </BaseListWrap>
        </BasePageWrap>
    );
}

export default SystemMsg;
